import { Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

function ProtectedRoutePortal() {
  const tokenCookie = Cookies.get("token");

  if (!tokenCookie) {
    window.location.href = process.env.REACT_APP_SITE_LOGIN;
    return null;
  }

  try {
    const { jwt } = JSON.parse(tokenCookie);
    const claims = jwtDecode(jwt);
    const grupoDeUsuarioId = Number(claims.GrupoDeUsuarioId);

    if (![2, 3, 4].includes(grupoDeUsuarioId)) {
      Cookies.remove("token");
      window.location.href = process.env.REACT_APP_SITE_LOGIN;
      return null;
    }

    return <Outlet />;
  } catch (error) {
    console.error("[PORTAL] erro rota protegida:", error);
    Cookies.remove("token");
    window.location.href = process.env.REACT_APP_SITE_LOGIN;
    return null;
  }
}

export default ProtectedRoutePortal;
